import { defineStore } from 'pinia';

export const useEventStore = defineStore('event', {
  state: () => ({
    events: [
      {
        id: 'tra-le-righe',
        target: 'adults',
        date: '2026-03-14',
        photos: []
      },
      {
        id: 'il-volto-dell-altro',
        target: 'fragile',
        date: '2026-05-29',
        photos: [],
        hide: true
      },
      {
        id: 'agire-per-scelta-non-per-paura',
        target: 'adults',
        date: '2025-10-24',
        photos: []
      },
      {
        id: 'la-relazione-che-cura',
        target: 'adults',
        date: '2025-03-22',
        photos: []
      },
      {
        id: 'l-amore-e-un-altra-cosa',
        target: 'teens',
        date: '2025-02-21',
        photos: []
      },
      {
        id: 'io-alla-tua-eta',
        target: 'adults',
        date: '2025-01-24',
        photos: []
      },
      {
        id: 'copriamo-le-distanze',
        target: 'teens',
        date: '2025-01-01',
        photos: [],
        hide: true
      }
    ]
  }),
  getters: {
    getEventById: (state) => (id) => {
      return state.events.find(event => event.id === id);
    }
  }
});
